import { useEffect } from 'react'
import {
  FulfilmentDetail,
  FulfilmentType,
} from '../../../../../../models/fulfilment'
import {
  CurrentView,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'

export const useLineItemFulfillmentDetailsChange = () => {
  const {
    currentView,
    fulfilmentDetails,
    setFulfilmentDetails,
  } = useLineItemFulfillmentContext()

  useEffect(() => {
    // When entering the Fulfillment Method view, default to Delivery if the fulfillment type is unspecified
    if (
      currentView === CurrentView.FULFILMENT_METHOD &&
      fulfilmentDetails.type === FulfilmentType.UNSPECIFIED
    ) {
      setFulfilmentDetails((state: FulfilmentDetail) => ({
        ...state,
        type: FulfilmentType.DELIVERY,
      }))
    }
  }, [currentView, fulfilmentDetails, setFulfilmentDetails])

  const handleSelectFulfillmentType = (type: FulfilmentType) => {
    setFulfilmentDetails((state: FulfilmentDetail) => ({
      ...state,
      type,
    }))
  }

  const handleNoteChange = (note: string) => {
    setFulfilmentDetails((state: FulfilmentDetail) => ({ ...state, note }))
  }

  return {
    handleSelectFulfillmentType,
    handleNoteChange,
  }
}
